import {css, html, LitElement} from 'lit';
import {customElement, property, state} from 'lit/decorators';
import {containerStyles, normalizeStyles} from '@webs/components-library/theming';
import {Logo} from './logo';
import {MainMenuItem} from '@webs/components-library/navigation-menu';

@customElement('webs-main-navigation')
export class MainNavigation extends LitElement {

  static styles = [
    normalizeStyles,
    containerStyles,
    css`
      :host {
        --default-link-hover-text-decoration: none;
        --default-link-color: var(--color-base);
        --default-link-color-hover: var(--color-primary);
        --default-link-font-weight: var(--font-weight-strong);
      }


      .main-navigation {
        left: 0;
        position: absolute;
        top: 0;
        transition: transform .1s linear;
        width: 100%;
        z-index: 999;
      }

      .main-navigation--fixed {
        position: fixed;
      }

      .main-navigation--hidden {
        transform: translateY(-100%);
      }

      .main-navigation__actions ::slotted(a) {
        color: var(--color-base);
        display: block;
        font-family: var(--font-family-alternative);
        font-size: .8rem;
        font-weight: var(--font-weight-semibold) !important;
        line-height: 1 !important;
        margin: .5rem 0;
        padding: .5rem 0;
        text-align: center;
        text-decoration: none;
      }

      @media only screen and (min-width: 1175px){
        .main-navigation__actions ::slotted(a) {
          border-bottom: 2px solid transparent;
          font-size: .7rem !important;
          margin: 0 .75rem 1.2rem;
          padding: 1.6rem 0 .3rem;
          position: relative;
        }

        .main-navigation__actions ::slotted(a:hover){
          color: var(--color-base) !important;
        }

        .main-navigation__actions ::slotted(a:last-of-type) {
          margin-right: 1rem;
        }

        .main-navigation__actions ::slotted(a:hover) {
          border-color: var(--color-base);
          color: var(--color-base) !important;
          text-decoration: none;
        }
      }
    `
  ];

  private smallDevice: MediaQueryList = window.matchMedia('(min-width: 1175px)');

  @state()
  private isDesktop: boolean;

  @property({type: Object, reflect: true})
  logo: Logo;

  @property({attribute: 'main-cta'})
  cta: string;

  @property({attribute: 'main-cta-text'})
  ctaTitle: string;

  @property({attribute: 'hubspot-cta'})
  isHubspotCta: boolean;

  @property({type: Array})
  menu: MainMenuItem[] = [
    {
      title: 'Why cleverbridge?',
      link: 'https://www.cleverbridge.com'
    },
    {
      title: 'Products',
      link: 'https://www.cleverbridge.com',
      submenuItems: [
        {
          title: 'Manage Global Ecommerce',
          items: [
            {
              title: 'Subscription management',
              link: 'https://www.cleverbridge.com'
            },
            {
              title: 'Data management',
              link: 'https://www.cleverbridge.com'
            },
            {
              title: 'Self-service',
              link: 'https://www.cleverbridge.com'
            },
            {
              title: 'Lifecycle marketing',
              link: 'https://www.cleverbridge.com'
            },
            {
              title: 'Global compliance',
              link: 'https://www.cleverbridge.com'
            }
          ]
        },
        {
          title: 'Monetize digital offerings',
          items: [
            {
              title: 'Billing & invoicing',
              link: 'https://www.cleverbridge.com'
            },
            {
              title: 'Payment processing',
              link: 'https://www.cleverbridge.com'
            },
            {
              title: 'Revenue retention',
              link: 'https://www.cleverbridge.com'
            },
            {
              title: 'Taxation',
              link: 'https://www.cleverbridge.com'
            },
            {
              title: 'Fraud prevention',
              link: 'https://www.cleverbridge.com'
            }
          ]
        },
        {
          title: 'Optimize recurring revenue',
          items: [
            {
              title: 'Localization',
              link: 'https://www.cleverbridge.com'
            },
            {
              title: 'Reporting',
              link: 'https://www.cleverbridge.com'
            },
            {
              title: 'Testing',
              link: 'https://www.cleverbridge.com'
            },
            {
              title: 'Success management',
              link: 'https://www.cleverbridge.com'
            },
            {
              title: 'Email marketing',
              link: 'https://www.cleverbridge.com'
            }
          ]
        },
        {
          title: 'Smart selling for B2B',
          items: [
            {
              title: 'Localization',
              link: 'https://www.cleverbridge.com'
            },
            {
              title: 'Success management',
              link: 'https://www.cleverbridge.com'
            },
            {
              title: 'Email marketing',
              link: 'https://www.cleverbridge.com'
            }
          ]
        }
      ]
    },
    {
      title: 'Client cases',
      link: 'https://www.cleverbridge.com',
      submenuItems: [
        {
          title: 'By strategy',
          items: [
            {
              title: 'Continously adapt',
              link: 'https://www.cleverbridge.com'
            },
            {
              title: 'Sell smarter',
              link: 'https://www.cleverbridge.com',
              description: 'Subtitle about manage pillar'
            }
          ]
        },
        {
          title: 'By use case',
          items: [
            {
              title: 'Expand globally',
              link: 'https://www.cleverbridge.com',
              description: 'Subtitle about manage pillar'
            },
            {
              title: 'Keep control of pricing',
              link: 'https://www.cleverbridge.com',
              description: 'Subtitle about manage pillar'
            },
            {
              title: 'Continously adapt',
              link: 'https://www.cleverbridge.com',
              description: 'Subtitle about manage pillar'
            },
            {
              title: 'Sell smarter',
              link: 'https://www.cleverbridge.com',
              description: 'Subtitle about manage pillar'
            }
          ]
        }
      ]
    },
    {
      title: 'Resources',
      link: 'https://www.cleverbridge.com',
      submenuItems: [
        {
          title: 'Smart selling for B2B',
          items: [
            {
              title: 'About cleverbridge',
              link: 'https://www.cleverbridge.com'
            },
            {
              title: 'Newsroom',
              link: 'https://www.cleverbridge.com'
            },
            {
              title: 'Partners',
              link: 'https://www.cleverbridge.com',
              description: 'Subtitle about manage pillar'
            },
            {
              title: 'Contact',
              link: 'https://www.cleverbridge.com'
            }
          ]
        }
      ]
    },
    {
      title: 'Company',
      link: 'https://www.cleverbridge.com',
      submenuItems: [
        {
          items: [
            {
              title: 'About cleverbridge',
              link: 'https://www.cleverbridge.com'
            },
            {
              title: 'Newsroom',
              link: 'https://www.cleverbridge.com'
            },
            {
              title: 'Partners',
              link: 'https://www.cleverbridge.com'
            },
            {
              title: 'Careers',
              link: 'https://www.cleverbridge.com',
              tag: 'We’re hiring'
            },
            {
              title: 'Contact',
              link: 'https://www.cleverbridge.com'
            }
          ]
        }
      ]
    },
  ];

  @property({attribute: 'fixed', type: Boolean})
  isFixed: boolean;

  connectedCallback() {
    super.connectedCallback();
    this.smallDevice.addEventListener('change', (e) => this.handleDeviceChange(e));
    let lastScrollTop = 0;
    this.isFixed = true;
    let animationEnd = false;
    setTimeout(() => {
      this.isFixed = false;
      animationEnd = true;
    }, 3000)

    window.addEventListener('scroll', () => {
      const scrollTop = window.pageYOffset;
      const nav = this.shadowRoot.querySelector('.main-navigation--fixed');
        if (nav && animationEnd) {
          if (scrollTop > lastScrollTop && scrollTop >= 80) {
            nav.classList.add('main-navigation--hidden');
          } else {
            nav.classList.remove('main-navigation--hidden');
          }
          lastScrollTop = scrollTop;
        }
    });
  }

  protected render(): unknown {
    this.handleDeviceChange(this.smallDevice);
    return this.isDesktop ? this.navigationDesktop : this.navigationMobile;
  }

  get navigationMobile(): unknown {
    return html`
      <section class="main-navigation ${this.isFixed ? 'main-navigation--fixed' : ''}">
        <webs-navigation-mobile .logo="${this.logo}" .menu="${this.menu}" main-cta="${this.cta}"
                                main-cta-text="${this.ctaTitle}">
          <div class="main-navigation__actions" slot="actions">
            <slot></slot>
          </div>
        </webs-navigation-mobile>
      </section>
    `;
  }

  get navigationDesktop(): unknown {
    return html`
      <section class="main-navigation ${this.isFixed ? 'main-navigation--fixed' : ''}">
        <webs-navigation-desktop .logo="${this.logo}" .menu="${this.menu}" main-cta="${this.cta}"
                                 main-cta-text="${this.ctaTitle}">
          <div class="main-navigation__actions" slot="actions">
            <slot></slot>
          </div>
        </webs-navigation-desktop>
      </section>
    `;
  }

  private handleDeviceChange(event): void {
    this.isDesktop = event.matches;
    this.requestUpdate();
  }
}
